"use strict";
/* Generated by ts-generator ver. 0.0.8 */
/* tslint:disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.YearnCurveMaxSafeSaviour = void 0;
var geb_contract_base_1 = require("@reflexer-finance/geb-contract-base");
var YearnCurveMaxSafeSaviour = /** @class */ (function (_super) {
    __extends(YearnCurveMaxSafeSaviour, _super);
    function YearnCurveMaxSafeSaviour() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    YearnCurveMaxSafeSaviour.prototype.HUNDRED = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "HUNDRED", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.MAX_LOSS = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "MAX_LOSS", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.MAX_UINT = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "MAX_UINT", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.ONE = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "ONE", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.RAY = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "RAY", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.THOUSAND = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "THOUSAND", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.WAD = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "WAD", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.WAD_COMPLEMENT = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "WAD_COMPLEMENT", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.addAuthorization = function (account) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "addAuthorization", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [account]);
    };
    YearnCurveMaxSafeSaviour.prototype.allowUser = function (usr) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "usr", "type": "address" }], "name": "allowUser", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [usr]);
    };
    YearnCurveMaxSafeSaviour.prototype.allowedUsers = function (address, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "allowedUsers", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [address], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.authorizedAccounts = function (address, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "authorizedAccounts", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [address], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.canSave = function (bytes, address) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }, { "internalType": "address", "name": "", "type": "address" }], "name": "canSave", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [bytes, address]);
    };
    YearnCurveMaxSafeSaviour.prototype.coinJoin = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "coinJoin", "outputs": [{ "internalType": "contract CoinJoinLike", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.curveLpToken = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "curveLpToken", "outputs": [{ "internalType": "contract ERC20Like", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.curvePool = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "curvePool", "outputs": [{ "internalType": "contract CurveV1PoolLike", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.curvePoolTokens = function (uinteger, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "name": "curvePoolTokens", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [uinteger], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.debtBelowFloor = function (collateralType, targetDebtAmount, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "bytes32", "name": "collateralType", "type": "bytes32" }, { "internalType": "uint256", "name": "targetDebtAmount", "type": "uint256" }], "name": "debtBelowFloor", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [collateralType, targetDebtAmount], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.defaultMaxLoss = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "defaultMaxLoss", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.defaultMinTokensToWithdraw = function (uinteger, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "name": "defaultMinTokensToWithdraw", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [uinteger], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.deposit = function (collateralType, safeID, lpTokenAmount) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "bytes32", "name": "collateralType", "type": "bytes32" }, { "internalType": "uint256", "name": "safeID", "type": "uint256" }, { "internalType": "uint256", "name": "lpTokenAmount", "type": "uint256" }], "name": "deposit", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [
            collateralType,
            safeID,
            lpTokenAmount,
        ]);
    };
    YearnCurveMaxSafeSaviour.prototype.disallowUser = function (usr) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "usr", "type": "address" }], "name": "disallowUser", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [usr]);
    };
    YearnCurveMaxSafeSaviour.prototype.getAccumulatedRateAndLiquidationPrice = function (collateralType, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "bytes32", "name": "collateralType", "type": "bytes32" }], "name": "getAccumulatedRateAndLiquidationPrice", "outputs": [{ "internalType": "uint256", "name": "accumulatedRate", "type": "uint256" }, { "internalType": "uint256", "name": "liquidationPrice", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [collateralType], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.getKeeperPayoutTokens = function (safeHandler, sysCoinsFromLP, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "safeHandler", "type": "address" }, { "internalType": "uint256", "name": "sysCoinsFromLP", "type": "uint256" }], "name": "getKeeperPayoutTokens", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [safeHandler, sysCoinsFromLP], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.getKeeperPayoutValue = function () {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "getKeeperPayoutValue", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, []);
    };
    YearnCurveMaxSafeSaviour.prototype.getReserves = function (safeID, token, dst) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "safeID", "type": "uint256" }, { "internalType": "address", "name": "token", "type": "address" }, { "internalType": "address", "name": "dst", "type": "address" }], "name": "getReserves", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [safeID, token, dst]);
    };
    YearnCurveMaxSafeSaviour.prototype.getSystemCoinMarketPrice = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "getSystemCoinMarketPrice", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.getTokensForSaving = function (collateralType, safeHandler, coinsLeft, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "bytes32", "name": "collateralType", "type": "bytes32" }, { "internalType": "address", "name": "safeHandler", "type": "address" }, { "internalType": "uint256", "name": "coinsLeft", "type": "uint256" }], "name": "getTokensForSaving", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [collateralType, safeHandler, coinsLeft], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.keeperPayout = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "keeperPayout", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.keeperPayoutExceedsMinValue = function () {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "keeperPayoutExceedsMinValue", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, []);
    };
    YearnCurveMaxSafeSaviour.prototype.liquidationEngine = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "liquidationEngine", "outputs": [{ "internalType": "contract LiquidationEngineLike", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.minKeeperPayoutValue = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "minKeeperPayoutValue", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.modifyParameters__Bytes32Address = function (parameter, data) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "bytes32", "name": "parameter", "type": "bytes32" }, { "internalType": "address", "name": "data", "type": "address" }], "name": "modifyParameters", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [parameter, data]);
    };
    YearnCurveMaxSafeSaviour.prototype.modifyParameters__Bytes32Uint256 = function (parameter, val) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "bytes32", "name": "parameter", "type": "bytes32" }, { "internalType": "uint256", "name": "val", "type": "uint256" }], "name": "modifyParameters", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [parameter, val]);
    };
    YearnCurveMaxSafeSaviour.prototype.oracleRelayer = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "oracleRelayer", "outputs": [{ "internalType": "contract OracleRelayerLike", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.payoutToSAFESize = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "payoutToSAFESize", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.removeAuthorization = function (account) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "removeAuthorization", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [account]);
    };
    YearnCurveMaxSafeSaviour.prototype.removedCurveCoinLiquidity = function (uinteger, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "name": "removedCurveCoinLiquidity", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [uinteger], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.restrictUsage = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "restrictUsage", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.safeEngine = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "safeEngine", "outputs": [{ "internalType": "contract SAFEEngineLike", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.safeIsAfloat = function (collateralType, safeHandler, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "bytes32", "name": "collateralType", "type": "bytes32" }, { "internalType": "address", "name": "safeHandler", "type": "address" }], "name": "safeIsAfloat", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [collateralType, safeHandler], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.safeManager = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "safeManager", "outputs": [{ "internalType": "contract GebSafeManagerLike", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.saveSAFE = function (keeper, collateralType, safeHandler) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "keeper", "type": "address" }, { "internalType": "bytes32", "name": "collateralType", "type": "bytes32" }, { "internalType": "address", "name": "safeHandler", "type": "address" }], "name": "saveSAFE", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }, { "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [
            keeper,
            collateralType,
            safeHandler,
        ]);
    };
    YearnCurveMaxSafeSaviour.prototype.saviourRegistry = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "saviourRegistry", "outputs": [{ "internalType": "contract SAFESaviourRegistryLike", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.systemCoin = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "systemCoin", "outputs": [{ "internalType": "contract ERC20Like", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.systemCoinOrcl = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "systemCoinOrcl", "outputs": [{ "internalType": "contract PriceFeedLike", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.taxCollector = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "taxCollector", "outputs": [{ "internalType": "contract TaxCollectorLike", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.tokenAmountUsedToSave = function (bytes, address) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }, { "internalType": "address", "name": "", "type": "address" }], "name": "tokenAmountUsedToSave", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [bytes, address]);
    };
    YearnCurveMaxSafeSaviour.prototype.underlyingReserves = function (address1, address2, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "", "type": "address" }, { "internalType": "address", "name": "", "type": "address" }], "name": "underlyingReserves", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [address1, address2], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.withdraw = function (collateralType, safeID, yvTokenAmount, maxLoss, dst) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "bytes32", "name": "collateralType", "type": "bytes32" }, { "internalType": "uint256", "name": "safeID", "type": "uint256" }, { "internalType": "uint256", "name": "yvTokenAmount", "type": "uint256" }, { "internalType": "uint256", "name": "maxLoss", "type": "uint256" }, { "internalType": "address", "name": "dst", "type": "address" }], "name": "withdraw", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [
            collateralType,
            safeID,
            yvTokenAmount,
            maxLoss,
            dst,
        ]);
    };
    YearnCurveMaxSafeSaviour.prototype.yVault = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "yVault", "outputs": [{ "internalType": "contract YVault3Like", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    YearnCurveMaxSafeSaviour.prototype.yvTokenCover = function (bytes, address, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }, { "internalType": "address", "name": "", "type": "address" }], "name": "yvTokenCover", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [bytes, address], multicall);
    };
    return YearnCurveMaxSafeSaviour;
}(geb_contract_base_1.BaseContractAPI));
exports.YearnCurveMaxSafeSaviour = YearnCurveMaxSafeSaviour;
